export const globalSequenceId = () => {
  if (!window.sequenceId) window.sequenceId = 0;

  window.sequenceId += 1;

  return window.sequenceId;
};
